import { render, staticRenderFns } from "./combine-table.vue?vue&type=template&id=454bfebc&scoped=true"
import script from "./combine-table.vue?vue&type=script&lang=js"
export * from "./combine-table.vue?vue&type=script&lang=js"
import style0 from "./combine-table.vue?vue&type=style&index=0&id=454bfebc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454bfebc",
  null
  
)

export default component.exports